import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PartnerTable from '../components/PartnerTable';

const PartnersPage = () => {
  let navigate = useNavigate();
  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <h1>Partners</h1>
        <Button variant="contained" color="primary" onClick={() => navigate('/partners/create')}>
          Create Partner
        </Button>
      </Box>
      <PartnerTable />
    </Box>
  );
};

export default PartnersPage;
